import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IMarkAsReadPayload extends ISagaCb {
    notificationId: string
    sagaCB: any
}

export interface IMarkAsReadState {
    status: string
    data: any
    errors: any
}

const initialState: IMarkAsReadState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const markAsRead = createSlice({
    name: 'notification/mark-as-read',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMarkAsReadPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const markAsReadActions = markAsRead.actions
export default markAsRead.reducer
